import { OWNER_PERMISSIONS } from "./permission";

/**
 * Drive 文件夹列表项
 */

/**
 * Drive 本地文件夹列表项
 */

/**
 * 列表的种类
 *
 * 对于前端来说 deprecated，全部使用 folderID 或 SpecialFolderID 来进行 query
 * 对后台来说还有用
 */
export var ListType = /*#__PURE__*/function (ListType) {
  ListType[ListType["All"] = 1] = "All";
  ListType[ListType["MyCreate"] = 2] = "MyCreate";
  ListType[ListType["Trash"] = 3] = "Trash";
  ListType[ListType["Shared"] = 4] = "Shared";
  ListType[ListType["MyDoc"] = 5] = "MyDoc";
  ListType[ListType["Recent"] = 6] = "Recent";
  ListType[ListType["Collection"] = 7] = "Collection";
  ListType[ListType["Storage"] = 8] = "Storage";
  ListType[ListType["ShareFolder"] = 9] = "ShareFolder";
  ListType[ListType["PreCreate"] = 11] = "PreCreate";
  ListType[ListType["RecentInTim"] = 15] = "RecentInTim";
  ListType[ListType["Safe"] = 16] = "Safe";
  return ListType;
}({});
export var DRIVE_FOLDER_KIND = 'drive#folder';

/** @deprecated 建议使用 OWNER_PERMISSIONS */
export var FOLDER_ATTRIBUTE = OWNER_PERMISSIONS;
export function isDriveFolder(node) {
  return node.kind === DRIVE_FOLDER_KIND && !node.isLocal;
}
export function isLocalDriveFolder(node) {
  return node.kind === DRIVE_FOLDER_KIND && node.isLocal;
}
//# sourceMappingURL=drive-folder.js.map